export default function transformVideoUrl(url, param) {
    var service = param.service;
    url.searchParams.append("loop", "1");
    url.searchParams.append("autoplay", "1");
    if (service === "youtube") {
        url.searchParams.append("mute", "1");
        url.searchParams.append("controls", "0");
        url.searchParams.append("rel", "0");
        url.searchParams.append("fs", "0");
        url.searchParams.append("disablekb", "1");
        url.searchParams.append("playsinline", "1");
        url.searchParams.append("modestbranding", "1");
    } else if (service === "vimeo") {
        url.searchParams.append("autopause", "0");
        url.searchParams.append("background", "1");
    }
    return url;
}

//# sourceMappingURL=transformVideoUrl.js.map